module.exports = __webpack_public_path__ + "static/media/track-sales.3495ad77.png";